import { Koi } from '@ksyos/koi';
import { SpecialismCode } from '@common/enums';
import { VatRateGroup } from '@common/enums/vatRateGroup';
import type { ISchemaContainer } from './schemaContainer';
import { ServiceCode } from '../enums/serviceCode';
import { ServiceType } from '../enums/serviceType';
import { ServiceZorgmailType } from '../enums/serviceZorgmailType';

export interface IServiceAddEditValidated {
    code: ServiceCode;
    contractFunding: boolean;
    customControlVersion: number;
    doNotDeclareSet: boolean;
    episodeCategoryId: string;
    isActive: boolean;
    isFundable: boolean;
    isStandaloneGraderNotAllowed: boolean;
    ksyosHolterAnalystOrganizationId: string | null;
    ledgerNumber: string;
    name: string;
    noGeneralPractitionerInvolved: boolean;
    runFundingAfterEachActivity: boolean;
    serviceType: ServiceType;
    specialismCode: string | null;
    supervisionPercentage: number | null;
    useNewFundingSystem: boolean;
    vatRateGroup: VatRateGroup;
    zorgmailType: ServiceZorgmailType;
}

export const serviceAddEditSchema: ISchemaContainer<IServiceAddEditValidated> = {
    schema: Koi.object({
        code: Koi.koi().enum(ServiceCode),
        contractFunding: Koi.boolean(),
        customControlVersion: Koi.number().integer().min(0),
        doNotDeclareSet: Koi.boolean(),
        episodeCategoryId: Koi.string().uuid(),
        isActive: Koi.boolean(),
        isFundable: Koi.boolean(),
        isStandaloneGraderNotAllowed: Koi.boolean(),
        isSuppressNotifications: Koi.boolean(),
        isSuppressZorgmail: Koi.boolean(),
        ksyosHolterAnalystOrganizationId: Koi.string().uuid().allow(null),
        ledgerNumber: Koi.string().ledgerNumber(),
        name: Koi.string().max(255),
        noGeneralPractitionerInvolved: Koi.boolean(),
        runFundingAfterEachActivity: Koi.boolean(),
        sendNotificationOnCloseSubsequentService: Koi.boolean(),
        sendZorgmailOnCloseSubsequentService: Koi.boolean(),
        serviceType: Koi.koi().enum(ServiceType),
        specialismCode: Koi.koi().enum(SpecialismCode).allow(null),
        supervisionPercentage: Koi.number().allow(null).min(0).max(100).integer(),
        useNewFundingSystem: Koi.boolean(),
        vatRateGroup: Koi.koi().enum(VatRateGroup),
        zorgmailType: Koi.koi().enum(ServiceZorgmailType),
    }).options({ convert: false, presence: 'required' }),
};
